import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StudentPicker } from "@/components/StudentPicker";
import { toast } from "sonner";
import { CheckCircle, WarningCircle, XCircle, Bandaids } from "@phosphor-icons/react";

const OPTIONS = [
  { v: "Hadir", icon: CheckCircle, color: "text-green-600", bg: "bg-green-50 border-green-300" },
  { v: "Izin", icon: WarningCircle, color: "text-amber-600", bg: "bg-amber-50 border-amber-300" },
  { v: "Sakit", icon: Bandaids, color: "text-orange-600", bg: "bg-orange-50 border-orange-300" },
  { v: "Alpha", icon: XCircle, color: "text-destructive", bg: "bg-red-50 border-red-300" },
];

export default function InputAbsensi() {
  const [students, setStudents] = useState([]);
  const [sid, setSid] = useState(null);
  const [status, setStatus] = useState("Hadir");
  const [timeIn, setTimeIn] = useState("07.30");
  const date = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    api.get("/students").then((r) => { setStudents(r.data); if (r.data[0]) setSid(r.data[0].id); });
  }, []);

  const save = async () => {
    if (!sid) return;
    try {
      await api.post("/attendance", { student_id: sid, date, status, time_in: status === "Hadir" ? timeIn : null, time_out: status === "Hadir" ? "11.40" : null });
      toast.success("Absensi tersimpan");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <PageHeader title="Input Absensi" />
      <div className="px-5 pt-4">
        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Pilih Siswa</p>
        <StudentPicker students={students} value={sid} onChange={setSid} />

        <div className="bg-primary/10 rounded-2xl px-4 py-3 mb-4">
          <p className="text-xs text-primary font-semibold">Tanggal</p>
          <p className="font-heading font-bold text-stone-800">{new Date(date).toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</p>
        </div>

        <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Status Kehadiran</p>
        <div className="grid grid-cols-2 gap-3 mb-4">
          {OPTIONS.map((o) => (
            <button
              key={o.v}
              data-testid={`status-${o.v}`}
              onClick={() => setStatus(o.v)}
              className={`rounded-2xl border-2 p-4 flex flex-col items-center gap-1 transition-colors ${status === o.v ? o.bg : "bg-white border-stone-200"}`}
            >
              <o.icon size={26} weight="fill" className={o.color} />
              <span className="font-semibold text-stone-700 text-sm">{o.v}</span>
            </button>
          ))}
        </div>

        {status === "Hadir" && (
          <div className="mb-4">
            <p className="text-xs text-stone-400 uppercase tracking-wide mb-2">Jam Masuk</p>
            <input data-testid="time-in-input" value={timeIn} onChange={(e) => setTimeIn(e.target.value)}
              className="w-full bg-white border border-stone-200 rounded-2xl py-3 px-4 outline-none focus:border-primary" />
          </div>
        )}

        <button data-testid="save-absensi-btn" onClick={save} className="w-full bg-primary text-white font-semibold py-4 rounded-full active:scale-95 transition-transform">
          Simpan Absensi
        </button>
      </div>
    </div>
  );
}
